module.exports = __webpack_public_path__ + "static/img/search_subcat_item_04_show.97231ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/release/search_subcat_item_04_show.jpg
// module id = /u18
// module chunks = 0